import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    this.showFlashMessages()
  }

  showFlashMessages() {
    const messages = this.containerTarget.querySelectorAll("[data-flash-message]")
    messages.forEach(msg => {
      const type = msg.dataset.flashType
      msg.style.background = type === "success" ? "#28a745" : "#dc3545"
      msg.style.color = "white"
      msg.style.padding = "15px 25px"
      msg.style.borderRadius = "8px"
      msg.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)"
      msg.style.minWidth = "300px"
      msg.style.textAlign = "center"
      msg.style.opacity = 0
      msg.style.transition = "opacity 0.5s ease, transform 0.5s ease"
      msg.style.transform = "translateY(-20px)"
      msg.style.marginBottom = "10px"

      // Fade in
      setTimeout(() => {
        msg.style.opacity = 1
        msg.style.transform = "translateY(0)"
      }, 50)

      // Fade out after 3 seconds
      setTimeout(() => {
        msg.style.opacity = 0
        msg.style.transform = "translateY(-20px)"
        setTimeout(() => msg.remove(), 500)
      }, 3000)
    })
  }
}
